import Vue from 'vue';
import VuePhotoSwipe from '@/plugins/PhotoSwipe';
Vue.use(VuePhotoSwipe);
